class CollectionRandomProducts extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    this.loadProducts();
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  shuffle(items) {
    for (let index = items.length - 1; index > 0; index -= 1) {
      const randomIndex = Math.floor(Math.random() * (index + 1));
      [items[index], items[randomIndex]] = [items[randomIndex], items[index]];
    }
    return items;
  }

  async loadProducts() {
    const list = this.querySelector('[data-collection-random-products-list]');
    const total = Number(this.dataset.collectionCount);
    const limit = Number(this.dataset.productLimit);
    const collectionUrl = this.dataset.collectionUrl;
    if (!list || !collectionUrl || !total || !limit) return;

    const pageCount = Math.ceil(total / 50);
    const pages = this.shuffle(Array.from({ length: pageCount }, (_, index) => index + 1)).slice(0, 8);

    const responses = await Promise.allSettled(
      pages.map(async (page) => {
        const url = new URL(collectionUrl, window.location.origin);
        url.searchParams.set('section_id', 'collection-random-products-feed');
        url.searchParams.set('page', String(page));
        const response = await fetch(url, { signal: this.abortController.signal });
        if (!response.ok) throw new Error('Collection recommendations unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        return html.querySelector('[data-collection-random-products-feed]');
      })
    );

    if (this.abortController.signal.aborted) return;

    const products = new Map();
    for (const response of responses) {
      if (response.status !== 'fulfilled' || !response.value) continue;
      for (const card of response.value.content.querySelectorAll('[data-product-id]')) {
        const id = card.dataset.productId;
        if (id !== this.dataset.currentProductId) products.set(id, card);
      }
    }

    if (products.size === 0) return;
    const selected = this.shuffle(Array.from(products.values())).slice(0, limit);
    list.replaceChildren(...selected.map((card) => card.cloneNode(true)));
  }
}

if (!customElements.get('collection-random-products')) {
  customElements.define('collection-random-products', CollectionRandomProducts);
}
